import { Theme, themes } from '../types';

interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  theme: typeof themes[Theme];
}

export function Switch({ checked, onChange, theme }: SwitchProps) {
  return (
    <button
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
        checked ? theme.switch.bgActive : theme.switch.bg
      }`}
    >
      <span
        className={`${
          checked ? 'translate-x-6' : 'translate-x-1'
        } inline-block h-4 w-4 transform rounded-full ${
          theme.switch.dot
        } transition-transform`}
      />
    </button>
  );
}